import { select, call } from 'redux-saga/effects';
import { SLOTS } from 'types';
import { isCommissionModeSelector } from '../selectors';
import { placedBetSelector } from '../../selectors';
import { IBets } from '../../types';
import { updateBetsSaga } from '../../sagas/createPendingBetSaga';

export function* changeCommissionModeSaga() {
  const isCommissionMode: boolean = yield select(isCommissionModeSelector);
  const currentBets: IBets = yield select(placedBetSelector);

  sessionStorage.setItem('commissionMode', JSON.stringify(isCommissionMode));

  const { past, present } = currentBets;
  const bankerBet = present[SLOTS.banker];

  if (bankerBet > 0) {
    yield call(updateBetsSaga, { past, present });
  }
}
